import { Box, Typography } from "@mui/joy";
import { ShieldAlert } from "lucide-react";

import { Button } from "../../shared";
import { useOrganizationImpersonation } from "../../hooks";

export default function ImpersonationBanner() {
    const { selectedOrganization, isImpersonating, stopImpersonation, isStopping } =
        useOrganizationImpersonation();

    if (!isImpersonating || !selectedOrganization) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                px: 2,
                py: 1,
                bgcolor: "warning.softBg",
                borderBottom: "1px solid",
                borderColor: "warning.outlinedBorder",
                flexShrink: 0,
            }}
        >
            <Box display="flex" alignItems="center" gap={1.5} minWidth={0}>
                <ShieldAlert size={18} />
                <Typography level="body-sm" sx={{ fontWeight: 600 }}>
                    Admin access: {selectedOrganization.Name}
                </Typography>
                <Typography level="body-xs" color="neutral">
                    You are viewing this organization as an administrator.
                </Typography>
            </Box>
            <Button
                size="sm"
                variant="soft"
                color="warning"
                loading={isStopping}
                onClick={() => stopImpersonation(selectedOrganization.Id)}
                sx={{ flexShrink: 0 }}
            >
                Exit
            </Button>
        </Box>
    );
}
